import React, { useState, useEffect } from "react";
import {
  Menu,
  X,
  Search,
  Bell,
  User,
  Moon,
  Sun,
  LogOut,
  Settings,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/Complete Inverse_10.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, text: "New feature available", time: "2 min ago" },
    { id: 2, text: "System update completed", time: "1 hour ago" },
    { id: 3, text: "Weekly report ready", time: "Yesterday" },
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Get user info from localStorage
  const username = localStorage.getItem("userName") || "John Doe";
  const companyname = localStorage.getItem("companyname") || "DropX Inc.";

  useEffect(() => {
    // Apply dark mode to document
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);
  return (
    <div className={`${darkMode ? "dark" : ""} m-0 p-0`}>
      <nav className="bg-[#002966] dark:bg-gray-900 w-full border-b dark:border-gray-700 transition-all duration-300 m-0">
        <div className="flex flex-wrap items-center justify-between mx-auto p-4">
          <motion.a
            href="/"
            className="flex items-center space-x-3"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.div
              className="rounded-xl flex items-center justify-center  p-1" // Added padding
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img
                src={logo} // Replace with your image path
                alt="Description" // Provide an appropriate alt text
                className="h-12 w-13 object-contain" // Adjust size and use object-contain
              />
            </motion.div>
            <div className="flex flex-col">
              <span className="text-xs text-white dark:text-gray-400">
                Logged in as: {username}
              </span>
            </div>
          </motion.a>
          <div className="flex md:order-2 space-x-3 md:space-x-4 items-center">
            {/* Notification Bell */}
            <div className="relative"></div>
            {/* User Menu */}
            <div className="relative">
              <motion.button
                className="flex items-center p-1 rounded-full text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-300"
                onClick={() => {
                  setShowUserMenu(!showUserMenu);
                  setShowNotifications(false);
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center text-white text-sm font-semibold">
                  {username.charAt(0)}
                </div>
              </motion.button>

              {/* User dropdown */}
              <AnimatePresence>
                {showUserMenu && (
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.2 }}
                    className="absolute right-0 mt-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-2 z-30 border border-gray-200 dark:border-gray-700"
                  >
                    <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                      <div className="flex items-center">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center text-white text-lg font-semibold mr-3">
                          {username.charAt(0)}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900 dark:text-white">
                            {username}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            {companyname}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="py-1">
                      <motion.a
                        href="/profile"
                        className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        whileHover={{ x: 5 }}
                      >
                        <User size={16} className="mr-3" />
                        My Profile
                      </motion.a>
                      <motion.a
                        href="/settings"
                        className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        whileHover={{ x: 5 }}
                      >
                        <Settings size={16} className="mr-3" />
                        Account Settings
                      </motion.a>
                      <div className="border-t border-gray-200 dark:border-gray-700 my-1"></div>
                      <motion.a
                        href="/logout"
                        className="flex items-center px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                        whileHover={{ x: 5 }}
                      >
                        <LogOut size={16} className="mr-3" />
                        Logout
                      </motion.a>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
